<template>
  <div v-if="$route.name === 'homepage'" class="package-type-switch">
    <button
      v-for="package_type_option in package_type_options"
      :key="package_type_option.value"
      :class="`package-type-switch--button ${
        package_type_option.value === package_type ? 'active' : ''
      }`"
      @click="() => select_package_type(package_type_option.value)"
    >
      {{ package_type_option.label }}
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { PACKAGE_TYPES } from "@alpitour/resources";
import { alpitour_rybbit_event } from "@alpitour/utilities/rybbit";
import { are_services_present } from "@/services";
import {
  get_configured_package_type,
  resolve_initial_package_type,
} from "./logic";

const only_stay_package_services = [
  "keyds",
  "keydsMap",
  "search",
  "details",
  "quote",
].map(base => `sololand.${base}`)

export default {
  name: "package-type-switch",

  props: {},

  data() {
    return {
      package_type_options: [
        {
          label: "Volo e soggiorno",
          value: PACKAGE_TYPES.FLIGHT_AND_STAY,
        },
        {
          label: "Solo soggiorno",
          value: PACKAGE_TYPES.ONLY_STAY,
        },
      ],
    };
  },

  mounted() {
    const allowed_package_types = this.get_allowed_package_types();

    // The configured tab only applies where the switch is visible: the booking
    // engine also mounts on results and detail, where changing package_type
    // would reset the search in progress.
    let configured_package_type = "";
    if (this.$route.name === "homepage") {
      configured_package_type = get_configured_package_type();
    }

    this.package_type_options = this.package_type_options.filter(
      (option) => allowed_package_types.indexOf(option.value) !== -1,
    );

    const initial_package_type = resolve_initial_package_type({
      allowed_package_types,
      configured_package_type,
      current_package_type: this.package_type,
      default_tab_set: this.default_tab_set,
    });

    // Committing package_type wipes the dependent search state, so only touch it
    // when it actually changes
    if (initial_package_type !== this.package_type) {
      this.package_type = initial_package_type;
    }

    // Latch once the configured tab was actually applicable — even when it
    // matched the current selection, so a customization edited later cannot
    // re-apply mid-session. An unprovisioned flow never consumes the one-shot.
    const configured_is_allowed =
      allowed_package_types.indexOf(configured_package_type) !== -1;
    if (configured_is_allowed && !this.default_tab_set) {
      this.$store.commit("liveat/default_tab_set", true);
    }
  },

  computed: {
    // module state keys
    ...mapState("liveat", [
      'default_tab_set',
    ]),

    package_type: {
      get() {
        return this.$store.state.liveat.package_type;
      },
      set(value) {
        this.$store.commit("liveat/package_type", value);
      },
    },
  },

  methods: {
    select_package_type(value) {
      if (this.package_type === value) {
        return;
      }
      this.package_type = value;
      this.$emit("change:package_type", value);
      alpitour_rybbit_event("package:type:select", {
        selected_type: value,
      });
    },
    get_allowed_package_types() {
      const allowed_package_types = [PACKAGE_TYPES.FLIGHT_AND_STAY]
      // If endpoints for the only-stay flow are present enable it
      if (are_services_present(only_stay_package_services)) {
        allowed_package_types.push(PACKAGE_TYPES.ONLY_STAY);
      }
      return allowed_package_types;
    },

  },
};
</script>

<style lang="scss" scoped>

  .package-type-switch {
    border-radius: 10px 10px 0 0;
    margin-bottom: -1px;
    z-index: 0;
    background-color: $extra2;
    display: inline-block;
    border: 1px solid rgba(255,255,255, .6);

    @include media-breakpoint-up(xl) {
      margin-left: -($grid-gutter-width / 2);
    }

    &--button {
      padding: ($grid-gutter-width / 3) ($grid-gutter-20 * 2);
      color: $gray-500;
      font-weight: $vb-font-weight-semibold;
      background: transparent;
      border: none;

      &:hover {
        color: $info;
      }

      &.active {
        background-color: $extra2;
        color: $primary;
        border: 1px solid $white;
        border-radius: 10px 10px 0 0;

        &:first-child {
          box-shadow: 3px 0 4px 0 rgba(0,0,0, .06)
        }

        &:last-child {
          box-shadow: -3px 0 4px 0 rgba(0,0,0, .06)
        }
      }
    }
  }

</style>
